(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("RLoginTransctions", [], factory);
	else if(typeof exports === 'object')
		exports["RLoginTransctions"] = factory();
	else
		root["RLoginTransctions"] = factory();
})(this, function() {
return 